import React, { SyntheticEvent } from 'react';
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent
} from '@mui/material';
import RangeSlider from '../../common/widgets/range-slider';
import OutlinedInputComponent from '../../common/widgets/outlined-input';
import { ISkills } from '../type';

interface IResourceAllocationProps {
  values: ISkills[];
  options: ISkills[];
  label: string;
  handleStatusChange: (event: SelectChangeEvent<ISkills[]>) => void;
  onNameChangeCallback: (value: string) => void;
  onNoOfProjectsChangeCallback: (value: number) => void;
  onCommittedCallback: (startValue: number, endValue: number) => void;
  handleClose: (event: SyntheticEvent) => void;
}

const ResourceAllocationFilter = ({
  label,
  values,
  options,
  handleStatusChange,
  onNameChangeCallback,
  onNoOfProjectsChangeCallback,
  onCommittedCallback,
  handleClose
}: IResourceAllocationProps): JSX.Element => {
  return (
    <Grid container spacing={4} columns={50}>
      <Grid
        item
        xs={50}
        sm={25}
        lg={12}
        sx={{
          '@media (max-width: 1351px)': {
            marginRight: '0px'
          }
        }}
      >
        <OutlinedInputComponent
          onChangeCallback={onNameChangeCallback}
          placeholder={'Search'}
          height={'48px'}
          width={'100%'}
          borderRadius={'8px'}
          fontSize={'16px'}
          fontWeight={'500'}
          color={'#5F6368'}
        />
      </Grid>
      <Grid item xs={50} sm={25} lg={13}>
        <RangeSlider onCommittedCallback={onCommittedCallback} />
      </Grid>
      <Grid item xs={50} sm={25} lg={12}>
        <OutlinedInputComponent
          onChangeCallback={(value: string) =>
            onNoOfProjectsChangeCallback(Number(value))
          }
          placeholder={'No:of Projects'}
          height={'48px'}
          width={'100%'}
          borderRadius={'8px'}
          fontSize={'16px'}
          fontWeight={'500'}
          color={'#5F6368'}
          startAdornmentVisible={false}
        />
      </Grid>
      <Grid item xs={50} sm={25} lg={13}>
        <FormControl
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '8px',
            borderRadius: '8px',
            maxWidth: '100%'
          }}
        >
          <Select
            multiple
            displayEmpty
            value={values}
            onClose={handleClose}
            onChange={(event) => {
              handleStatusChange(event);
            }}
            renderValue={() => label}
            sx={{
              borderRadius: '8px',
              maxHeight: '48px',
              width: '100%'
            }}
            fullWidth
            MenuProps={{
              PaperProps: {
                sx: {
                  ...{
                    maxHeight: '230px',
                    scrollPadding: '0px',
                    '&::-webkit-scrollbar': {
                      width: '7px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(217, 217, 217, 1)',
                      borderRadius: '10px'
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: 'rgba(217, 217, 217, 0.4)',
                      borderRadius: '10px'
                    }
                  }
                }
              }
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.displayName} value={option.displayName}>
                <Checkbox
                  checked={values.includes(
                    option.displayName as unknown as ISkills
                  )}
                />
                <ListItemText primary={option.displayName} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ResourceAllocationFilter;
